import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import {FontAwesomeIcon}  from "@fortawesome/vue-fontawesome"
import {library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons"


axios.defaults.baseURL = 'https://outstaff.bls-soft.ru'

export const MAX_COUNT_FILES = '5'
export const MAX_SIZE_FILES = '50'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  vuetify,
  render: h => h(App)
}).$mount('#app')
